import { useEffect, useState } from 'react';
import DelayedLoader from './DelayedLoader';
import { getScreenConfig } from './api';
import { CenteredContainer } from './styles';

export const FunnelScreen = ({
  screenId,
  onSelect,
}: {
  screenId: number;
  onSelect: Function;
}) => {
  const [screenConfig, setScreenConfig] =
    useState<Awaited<ReturnType<typeof getScreenConfig>>>(null);

  useEffect(() => {
    getScreenConfig(screenId).then(setScreenConfig);
  }, [screenId]);

  if (!screenConfig) {
    return (
      <CenteredContainer>
        <DelayedLoader />
      </CenteredContainer>
    );
  }

  const { component, key, ...props } = screenConfig;
  const Component = component;

  if (!component) {
    return null;
  }

  return (
    <Component
      {...props}
      onSelect={value => onSelect(key, value, screenConfig)}
    />
  );
};

export default FunnelScreen;
